import React, {useContext} from 'react';
import {I18nContext} from 'react-i18next';
import PropTypes from 'prop-types';
import flagImg from '@/Fi16100/Images/SuomalPalvelua_ValkNega_rgb.webp';
import platinumImg from '@/Fi16100/Images/STANDING_WHITE_1080x952.webp';
import {usePage} from '@inertiajs/react';
import Link from '@/Fi16100/Components/Link';
import FooterLinks from '@/Fi16100/Components/FooterLinks.jsx';
import './Footer.css';

function Footer(props) {
	const t = useContext(I18nContext).i18n.t;
	const businessSiteOrigin = String(usePage().props.businessSiteOrigin);

	//const containerClass = 'container d-flex justify-content-center d-lg-block py-4';
	//const rowClass = 'row w-auto d-flex flex-column flex-lg-row justify-content-center';
	//const columnClass = 'w-auto col-md-6 col-lg mb-3';

	return (
		<footer className={(props.className ?? '') + ' footer w-100'}>
			<div className="footer-top">
				<FooterLinks className="py-4" />
			</div>

			<div className="footer-bottom text-white">
				<div className="container py-5">
					<div className="row d-flex">
						<div className="order-1 col-6 order-lg-1 col-lg-2 mb-4 mb-lg-0 d-flex justify-content-end">
							<img src={flagImg} alt={t('footer.bottom.flag')} className="cert-img user-select-none p-2" />
						</div>

						<div className="order-2 col-6 order-lg-3 col-lg-2 mb-4 mb-lg-0 d-flex justify-content-start">
							<img src={platinumImg} alt={t('footer.bottom.platinum')} className="cert-img user-select-none" />
						</div>

						<div className="order-3 order-lg-2 col-12 col-lg-8 d-flex flex-column justify-content-center">
							<div className="fs-5 fw-semibold text-center mb-1">
								{t('footer.bottom.slogan')}
							</div>

							<div className="text-center mb-1">
								<span>{t('footer.bottom.info')}</span>
							</div>

							<div className="d-flex flex-wrap justify-content-center">
								<Link href={route('fi16100.terms')} className="link-white mx-1">
									{t('footer.bottom.terms')}
								</Link>

								<Link href={route('fi16100.privacy-policy')} className="link-white mx-1">
									{t('footer.bottom.privacy')}
								</Link>

								<Link href={route('fi16100.data-protection')} className="link-white mx-1">
									{t('footer.bottom.data')}
								</Link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
}

Footer.propTypes = {
	className: PropTypes.string
};

export default Footer;
